import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { NavigationLink } from '../components';

import { ThemeImages, ThemeColors } from '../theme';

class AccountActivated extends Component {

  render() {
    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      marginTop: 'calc(50vh - 215px)',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
    };
    const formGroupStyle = {
      width: '100%',
      textAlign: 'center',
    };
    return (

      <div style={containerStyle}>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} alt="Logo" style={{ width: '100%' }} />
        </div>
        <AppBar title="Account aktiviert" titleStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white', fontSize: 14 }} showMenuIconButton={false} style={{ textAlign: 'center' }} />

        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <span> Ihr Account wurde erfolgreich aktiviert.</span>
          <br />
          <span> Sie können sich jetzt anmelden.</span>
          <br /><br />
          <NavigationLink to="login">Jetzt einloggen</NavigationLink>
        </div>
      </div>
    );
  }
}


export default AccountActivated;



// WEBPACK FOOTER //
// ./src/app/activateaccount/accountactivated.js